<template>
  <div class="pa-5">
       <v-row class="pa-5">
                        <v-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6" v-for="item in items" :key="item.id">
              <!-- There is no need in using router link to encapsulate the v-card, the V-card has a to="" attribute -->
              <v-card :to="{path:`/product/${item.id}`}" tile>
                  
                  <v-row>
                      <v-col cols="12" xs="5" sm="5" md="5" lg="5" xl="5" class="pa-10">
                  <h3>{{item.itemData.name}}</h3>
                    <h4>${{item.itemData.variations[0].itemVariationData.priceMoney.amount*0.01}}</h4>
                  </v-col>
                  <v-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6" class="pa-10">
                      <p class="text-center">
                   <img class="pt-1" :src="item.itemData.description" height="100"/>
                   </p>
                   </v-col>
                  </v-row>
              </v-card>
            
           </v-col>

                  
                 

      </v-row>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data(){
          return {
               items:[]
          }
     },
     mounted(){
        axios.get('https://zaastry-node.herokuapp.com/item/cbb').then(res=>{
             console.log(res.data,"my res")
             this.items=res.data
         })
        .catch(err=>{
            console.log(err)
        })
    }
}
</script>

<style>

</style>